import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import PostGrid from '../ai-notes/components/PostGrid';
import NewsletterSignup from '../ai-notes/NewsletterSignup';
import ToolsSection from './ToolsSection';

const Home = ({auth}) => {
    const [recentPosts, setRecentPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchRecentPosts();
    }, []);

    const fetchRecentPosts = async () => {
        try {
            setLoading(true);
            const response = await fetch('/api/posts', {
                credentials: 'include'
            });

            if (response.ok) {
                const data = await response.json();
                if (data.posts && Array.isArray(data.posts)) {
                    // Filter posts within 30 days and take first 3
                    const thirtyDaysAgo = new Date();
                    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                    const recent = data.posts
                        .filter(post => post.posted_at && new Date(post.posted_at) >= thirtyDaysAgo)
                        .slice(0, 3);
                    setRecentPosts(recent);
                } else {
                    setRecentPosts([]);
                }
            } else {
                setRecentPosts([]);
            }
        } catch (err) {
            console.error('Error fetching recent posts:', err);
            setRecentPosts([]);
        } finally {
            setLoading(false);
        }
    };
    const projects = [
        {
            title: "AI Demo & Learn",
            url: "https://aidemolearn.com",
            description: "A community of builders, creators, and dreamers that gathers for monthly deep dives, demos, and exploration. In addition, we encourage small groups of people to form their own learning groups to turbocharge their learnings."
        },
        {
            title: "Teq Crew",
            url: "https://teqcrew.com",
            description: "Consulting company for small and medium size businesses to help with their technology needs from website creation, marketing, and lead generation."
        },
        {
            title: "Career Amplifier",
            url: "https://careeramplifier.com",
            description: "Platform to help job seekers discover jobs and then setup an automated email that sends emails each day with new job postings that fit the user's specific criteria."
        },
        {
            title: "RecapVid",
            url: "https://recapvid.com",
            description: "AI-generated, hyperpersonalized video tool that roasts fantasy football leagues with searing, personalized, and customizable videos that are generated end-to-end with AI."
        }
    ];

    return (
        <div style={{
            background: 'linear-gradient(135deg, rgba(232, 232, 232, 0.92) 0%, rgba(248,250,252,0.95) 100%)',
            minHeight: 'auto',
            padding: '120px 60px 0px 60px',
            margin: '0',
            width: '100%'
        }}>
                <div style={{ width: '100%', maxWidth: 'none' }}>
                    <Row className="justify-content-center">
                        <Col lg={10}>
                            {/* Hero Section */}
                            <Row className="justify-content-center align-items-start" style={{ marginBottom: '100px' }}>
                        {/* Left Column - Photo Only */}
                        <Col lg={4} className="text-center">
                            <img 
                                src="/images/elliot-koss.jpeg" 
                                alt="Elliot Koss" 
                                style={{
                                    width: '280px',
                                    height: '280px',
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                    border: '4px solid rgba(255,255,255,0.8)',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}
                            />
                        </Col>
                        
                        {/* Right Column - Name, Title, Description, and Social Links */}
                        <Col lg={6} className="text-left" style={{ paddingLeft: '2rem' }}>
                            <h1 style={{
                                fontSize: '3.5rem',
                                fontWeight: '300',
                                color: '#2d3748',
                                marginBottom: '0.5rem',
                                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                                textAlign: 'left'
                            }}>
                                Elliot Koss
                            </h1>
                            <p style={{
                                fontSize: '1.4rem',
                                color: '#4a5568',
                                fontWeight: '400',
                                marginBottom: '0.8rem',
                                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                                textAlign: 'left'
                            }}>
                                AI Product, Data & Strategy Leader
                            </p>
                            <p style={{
                                fontSize: '1.1rem',
                                color: '#718096',
                                maxWidth: '600px',
                                lineHeight: '1.6',
                                marginBottom: '1.5rem',
                                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                                textAlign: 'left'
                            }}>
                                Product management leader with a proven track record of delivering high impact, personalized experiences and leveraging Machine Learning and Artificial Intelligence. 10+ years of experience leading cross-functional teams who drive business growth.
                            </p>
                            
                            {/* Social Links below text */}
                            <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                                <a 
                                    href="https://linkedin.com/in/elliotkoss" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        textDecoration: 'none',
                                        color: '#4a5568',
                                        transition: 'color 0.3s ease'
                                    }}
                                    onMouseOver={(e) => e.target.style.color = '#2d3748'}
                                    onMouseOut={(e) => e.target.style.color = '#4a5568'}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                    </svg>
                                    <span style={{ marginLeft: '8px', fontSize: '1rem' }}>LinkedIn</span>
                                </a>
                                <a 
                                    href="https://github.com/elliotkoss" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        textDecoration: 'none',
                                        color: '#4a5568',
                                        transition: 'color 0.3s ease'
                                    }}
                                    onMouseOver={(e) => e.target.style.color = '#2d3748'}
                                    onMouseOut={(e) => e.target.style.color = '#4a5568'}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                                    </svg>
                                    <span style={{ marginLeft: '8px', fontSize: '1rem' }}>GitHub</span>
                                </a>
                            </div>
                        </Col>
                            </Row>
                            
                            {/* Subtle divider line */}
                            <div style={{
                                width: '100%',
                                height: '1px',
                                background: 'linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.1) 50%, transparent 100%)',
                                margin: '50px 0'
                            }}></div>

                            {/* Projects Section */}
                            <h2 style={{
                                fontSize: '2rem',
                                fontWeight: '300',
                                color: '#2d3748',
                                textAlign: 'center',
                                marginBottom: '2rem',
                                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                            }}>
                                Featured Projects
                            </h2>
                            
                            <Row className="g-4 pb-5">
                        {projects.map((project, index) => (
                            <Col key={index} md={6} lg={4}>
                                <Card style={{
                                    border: 'none',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    height: '100%',
                                    
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
                                }}>
                                    <Card.Body style={{ padding: '2rem' }}>
                                        <Card.Title style={{
                                            fontSize: '1.25rem',
                                            fontWeight: '600',
                                            color: '#2d3748',
                                            marginBottom: '1rem',
                                            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                                        }}>
                                            {project.title}
                                        </Card.Title>
                                        <Card.Text style={{
                                            color: '#4a5568',
                                            lineHeight: '1.6',
                                            marginBottom: '1.5rem',
                                            fontSize: '0.95rem',
                                            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                                        }}>
                                            {project.description}
                                        </Card.Text>
                                        <a 
                                            href={project.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#667eea',
                                                textDecoration: 'none',
                                                fontWeight: '500',
                                                fontSize: '0.9rem',
                                                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                                            }}
                                            onMouseOver={(e) => e.target.style.color = '#5a67d8'}
                                            onMouseOut={(e) => e.target.style.color = '#667eea'}
                                        >
                                            Visit Project →
                                        </a>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                            </Row>

                            {/* Subtle divider line */}
                            <div style={{
                                width: '100%',
                                height: '1px',
                                background: 'linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.1) 50%, transparent 100%)',
                                margin: '50px 0'
                            }}></div>

                            {/* Tools Section */}
                            <ToolsSection />

                            {/* Subtle divider line */}
                            {!loading && recentPosts.length > 0 && (
                                <div style={{
                                    width: '100%',
                                    height: '1px',
                                    background: 'linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.1) 50%, transparent 100%)',
                                    margin: '50px 0'
                                }}></div>
                            )}

                            {/* AI Notes Section */}
                            {!loading && recentPosts.length > 0 && (
                                <>
                                    <h2 style={{
                                        fontSize: '2rem',
                                        fontWeight: '300',
                                        color: '#2d3748',
                                        textAlign: 'center',
                                        marginBottom: '1rem',
                                        fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                                    }}>
                                        AI Notes
                                    </h2>
                                    <p style={{
                                        fontSize: '1rem',
                                        color: '#718096',
                                        textAlign: 'center',
                                        marginBottom: '1rem',
                                        maxWidth: '700px',
                                        margin: '0 auto 1rem auto',
                                        lineHeight: '1.6',
                                        fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                                    }}>
                                        A place where I write regular notes about AI tools and what I'm using. Here you'll find nerdy details and technical insights that wouldn't make sense for LinkedIn. I'll talk about all the tools I'm exploring and working with.
                                    </p>
                                    <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                                        <Link 
                                            to="/ai-notes"
                                            style={{
                                                color: '#667eea',
                                                textDecoration: 'none',
                                                fontWeight: '500',
                                                fontSize: '0.95rem',
                                                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                transition: 'color 0.2s ease'
                                            }}
                                            onMouseOver={(e) => e.target.style.color = '#5a67d8'}
                                            onMouseOut={(e) => e.target.style.color = '#667eea'}
                                        >
                                            View All AI Notes →
                                        </Link>
                                    </div>
                                    
                                    <PostGrid posts={recentPosts} />
                                    
                                    {/* Newsletter Signup */}
                                    <div style={{ marginTop: '1rem', marginBottom: '6rem' }}>
                                        <NewsletterSignup />
                                    </div>
                                </>
                            )}

                        </Col>
                    </Row>
                </div>
        </div>
    );
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Home);
